import ClientOnly from "../components/ClientOnly";
import Auth from "../components/Views/Auth";
function LoginIndex() {
  return (
    <div>
      <ClientOnly>
        <Auth />
      </ClientOnly>
    </div>
  );
}

export default LoginIndex;
